export const AI_SESSION_SETTINGS = {
  RELAY_BASE_URL: 'config:ai_session_relay_url',
} as const;
